// extracted by mini-css-extract-plugin
export default {"MainDiv":"WaitingComp_MainDiv__m93FF"};